import DadosIniciais from '../ModulosCrefito/DadosIniciais'
import DadosEstabelecimento from '../ModulosCrefito/DadosEstabelecimento'
import Consultorio from './TiposFisio/Consultorio'
import Livre from './TiposFisio/Livre'
import Caps from './TiposFisio/Caps'
import Clinica from './TiposFisio/Clinica'
import Nasf from './TiposFisio/Nasf'
import ExercicioIlegal from './TiposFisio/ExercicioIlegal'
import RedeSocial from './TiposFisio/RedeSocial'
import Ilpis from './TiposFisio/Ilpis'
import Hospital from './TiposFisio/Hospital'
import Fechado from './Fechado'
import Cabecalho from '../../Views/Form/Cabecalho'
import Assinaturas from '../../Views/Form/Assinaturas'
import QrCode from '../../Views/Form/QrCode'
import AiView from '../AIs/AisFisio/AiView'

import React from 'react'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ficha, setModo } from '../../../state/slices/formSlice'

const Container = () => {
    const [tipo, setTipo] = useState()
    const id = window.location.pathname.slice(13)
    const dispatch = useDispatch()
    const [paf, setPaf] = useState({})

    useEffect(() => {
        const url = '/api/tvs/getTvfisio'
        axios.post(url, {id})
            .then(res => {
                dispatch(ficha(res.data))
                dispatch(setModo())
                setTipo(res.data.tipo)
                setPaf(res.data.dadosEstabelecimento[0])
                console.log(res.data)
            })
            .catch(error => {
                alert(error)
            })
    }, [])

    return (
        <>
            <Cabecalho valor={paf} />
            <DadosIniciais modulo="dadosIniciais" />
            <DadosEstabelecimento modulo="dadosEstabelecimento" />
            {RenderFicha()}
            <Assinaturas profissao="de Fisioterapia" />
            <QrCode tipo="brancoView" id={id}/>
            <AiView />
        </>
    )

    function RenderFicha() {
        if (tipo === "Consultorio") return <Consultorio />
        else if (tipo === "Livre") return <Livre />
        else if (tipo === "Caps") return <Caps />
        else if (tipo === "Clínica") return <Clinica />
        else if (tipo === "Nasf") return <Nasf />
        else if (tipo === "Exercício Ilegal") return <ExercicioIlegal />
        else if (tipo === "Rede Social") return <RedeSocial />
        else if (tipo === "Ilpis") return <Ilpis />
        else if (tipo === "Hospital") return <Hospital />
        else if (tipo === "Fechado/Desativado") return <Fechado />
    }
}

export default Container